module.exports = __webpack_public_path__ + "static/media/nitp.cbde4158.png";